import Script from 'next/script';

declare const metricsPlugin: {
  plugin: (globalId: string, app: string, language?: string) => void;
};

type NpsMetricScriptProps = {
  globalId?: string;
  preferredLanguage?: string;
};

function NpsMetricScript({
  globalId,
  preferredLanguage,
}: NpsMetricScriptProps) {
  if (!globalId) return null;
  return (
    <Script
      type="text/javascript"
      src={process.env.NEXT_PUBLIC_METRICS_URL}
      strategy="afterInteractive"
      onLoad={() => {
        try {
          metricsPlugin.plugin(globalId, 'OPR', preferredLanguage);
        } catch (error) {
          console.error('Failed to initialize the metrics plugin.', error);
        }
      }}
      onError={() => {
        console.error('Failed to load the metrics script.');
      }}
    />
  );
}

export const NPS = {
  Script: NpsMetricScript,
};
